import { apiFetch } from "./client";

export interface ChannelConfig {
  id: string;
  workspaceId: string;
  sourceChannelId: string;
  targetChannelId: string;
  timezone: string;
  runAtHourLocal: number;
  enabled: boolean;
  createdAt: string;
  /** Joined from the owning workspace. */
  teamName: string;
  workspaceStatus: string;
}

export async function listConfigs(): Promise<ChannelConfig[]> {
  const data = await apiFetch<{ configs: ChannelConfig[] }>("/api/config");
  return data.configs;
}

export async function createConfig(input: {
  workspaceId: string;
  sourceChannelId: string;
  targetChannelId: string;
  timezone: string;
  runAtHourLocal: number;
  enabled: boolean;
}) {
  return apiFetch<{ id: string }>("/api/config", {
    method: "POST",
    json: input,
  });
}

export async function deleteConfig(id: string) {
  return apiFetch(`/api/config/${id}`, { method: "DELETE" });
}

export async function getLastSyncAt(): Promise<Date | null> {
  const data = await apiFetch<{ lastReportAt: string | null }>(
    "/api/health/sync",
  );
  return data.lastReportAt ? new Date(data.lastReportAt) : null;
}
